import React from 'react';
import { FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { FieldValues } from 'react-hook-form/dist/types';

import { CustomGoal } from './CustomGoal';
import { TargetArea } from './TargetArea';
import ValueExpression from '../../../valueexpressions/models/valueexpressions/ValueExpression';
import { DefaultGoal } from './DefaultGoal';

type Props<T extends FieldValues> = {
  valueExpression: ValueExpression;
  getValues: (id: string) => string;
  watch: <T>(id: string) => T;
  setValue: UseFormSetValue<T>;
  errors: FieldErrors;
  trigger: UseFormTrigger<T>;
};

export const KpiCustomThresholdSelectionFormBody = <T extends FieldValues>({
  watch,
  valueExpression,
  getValues,
  setValue,
  errors,
  trigger,
}: Props<T>) => {
  const activeMode = watch('activeViewMode');

  if (valueExpression.positiveDirection !== 'custom') {
    return (
      <DefaultGoal
        watch={watch}
        valueExpression={valueExpression}
        getValues={getValues}
        setValue={setValue}
        errors={errors}
        trigger={trigger}
      />
    );
  }

  if (activeMode === 'limit') {
    return (
      <CustomGoal
        watch={watch}
        valueExpression={valueExpression}
        getValues={getValues}
        setValue={setValue}
        errors={errors}
        trigger={trigger}
      />
    );
  }

  return (
    <TargetArea watch={watch} valueExpression={valueExpression} setValue={setValue} errors={errors} trigger={trigger} />
  );
};
